import { __decorate, __metadata } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import ButtonMiniAction from '../components/buttons/ButtonMiniAction/ButtonMiniAction';
import { CosmicIcons } from '../utils/ui/CosmicIcons';
let BaseButtonMiniActionImplementation = class BaseButtonMiniActionImplementation extends ButtonMiniAction {
    $icons = CosmicIcons;
    tooltip;
    tooltipPosition;
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], BaseButtonMiniActionImplementation.prototype, "tooltip", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: 'left'
    }),
    __metadata("design:type", Object)
], BaseButtonMiniActionImplementation.prototype, "tooltipPosition", void 0);
BaseButtonMiniActionImplementation = __decorate([
    Component
], BaseButtonMiniActionImplementation);
export default BaseButtonMiniActionImplementation;
